import { render, staticRenderFns } from "./EventCardPeriod.vue?vue&type=template&id=a2197520"
import script from "./EventCardPeriod.vue?vue&type=script&lang=js"
export * from "./EventCardPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports